const dev = {
  API_ENDPOINT_URL: "https://api.baauto.fr/api",
  BACKEND_URL: "https://api.baauto.fr",
}

const prod = {
  API_ENDPOINT_URL: "https://api.baauto.fr/api",
  BACKEND_URL: "https://api.baauto.fr",
}

const test = {
  API_ENDPOINT_URL: "https://api.baauto.fr/api",
  BACKEND_URL: "https://api.baauto.fr",
}

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev
    case "production":
      return prod
    case "test":
      return test
    default:
      break
  }
}

export const env = getEnv()
